import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Trans, withTranslation } from "react-i18next";
import styled from "styled-components";
import { cssMainSelector } from "../lib/cssSelectors";
import { CSS_CLASS_PREFIX } from "../constants/css";
import { OFFER_TYPES } from "../constants/offerTypes";

const CurrentResultsCountWrapper = styled.span`
  ${p => cssMainSelector(p.theme.tdsId)} {
    color: ${p => p.theme.color.darkGray};
    font-size: ${p => p.theme.font.sizeXs};
  }
`;

const CountWrapper = styled.span`
  ${p => cssMainSelector(p.theme.tdsId)} {
    color: ${p => p.theme.color.darkGray};
    font-size: ${p => p.theme.font.sizeXs};
    font-weight: ${p => p.theme.font.weightBold};
  }
`;

class CurrentResultsCount extends PureComponent {
  render() {
    return (
      <CurrentResultsCountWrapper>{this.text()}</CurrentResultsCountWrapper>
    );
  }

  text() {
    const { count, offerType } = this.props;

    if (offerType === OFFER_TYPES.phoneOffer) {
      return (
        <Trans i18nKey="phoneOfferText" count={count} ns="currentResultsCount">
          The best{" "}
          <CountWrapper className={`${CSS_CLASS_PREFIX}-current-results-count`}>
            {{ count }}
          </CountWrapper>{" "}
          smartphone deals.
        </Trans>
      );
    } else if (offerType === OFFER_TYPES.proposition) {
      return (
        <Trans i18nKey="propositionText" count={count} ns="currentResultsCount">
          The best{" "}
          <CountWrapper className={`${CSS_CLASS_PREFIX}-current-results-count`}>
            {{ count }}
          </CountWrapper>{" "}
          deals.
        </Trans>
      );
    } else if (offerType === OFFER_TYPES.simOnly) {
      return (
        <Trans i18nKey="simOnlyText" count={count} ns="currentResultsCount">
          The best{" "}
          <CountWrapper className={`${CSS_CLASS_PREFIX}-current-results-count`}>
            {{ count }}
          </CountWrapper>{" "}
          SIM Only deals.
        </Trans>
      );
    }
  }
}

CurrentResultsCount.propTypes = {
  count: PropTypes.number.isRequired,
  offerType: PropTypes.string.isRequired
};

export default withTranslation(["currentResultsCount"])(CurrentResultsCount);
